/* eslint-disable max-len */
export enum DefaultFolderActionType {
    SetDefaultFolder = 'defaultFolder.SET_DEFAULT_FOLDER',
    SetDefaultFolderModalStep = 'defaultFolder.SET_DEFAULT_FOLDER_MODAL_STEP',
    SetFormDefaultFolderId = 'defaultFolder.SET_DEFAULT_FOLDER_ID_FORM',
    SetFormDefaultFolderPath = 'defaultFolder.SET_DEFAULT_FOLDER_PATH_FORM',
    SetFormDefaultFolderScope = 'defaultFolder.SET_DEFAULT_FOLDER_SCOPE_FORM',
    SetFormDefaultFolderCircles = 'defaultFolder.SET_DEFAULT_FOLDER_CIRCLES_FORM',
}
